var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticStyle:{"background":"#f6f6f6"},attrs:{"height":"78"}},[_c('div',{staticClass:"layout column align-center"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png"),"width":"200","height":"30"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }